// language=GraphQL
export const ALL_CMS_QUERY = `query Query($withHomepage: Boolean = false, $withHomepageSeoSettings: Boolean = false, $withHomepageSeoSettingsOgImage: Boolean = false, $withHomepageContentBlockAssignments: Boolean = false, $withHomepageContentBlockAssignmentsBlock: Boolean = false, $withCategories: Boolean = false, $withCategoriesPages: Boolean = false, $withCategoriesPagesSeoSettings: Boolean = false, $withCategoriesPagesContentBlockAssignments: Boolean = false, $withCategoriesSeoSettings: Boolean = false, $withCategoriesSeoSettingsOgImage: Boolean = false, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withErrorPage404: Boolean = false, $withErrorPage404SeoSettings: Boolean = false, $withErrorPage404SeoSettingsOgImage: Boolean = false, $withErrorPage404ContentBlockAssignments: Boolean = false, $withErrorPage404ContentBlockAssignmentsBlock: Boolean = false, $withErrorPage500: Boolean = false, $withErrorPage500SeoSettings: Boolean = false, $withErrorPage500SeoSettingsOgImage: Boolean = false, $withErrorPage500ContentBlockAssignments: Boolean = false, $withErrorPage500ContentBlockAssignmentsBlock: Boolean = false, $withConfig: Boolean = false, $withConfigContactBlockSettings: Boolean = false, $withConfigSocialMediaSettings: Boolean = false, $withConfigPrivacyPolicyPage: Boolean = false, $withConfigPrivacyPolicyPageSeoSettings: Boolean = false, $withConfigPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withConfigGtcPage: Boolean = false, $withConfigGtcPageSeoSettings: Boolean = false, $withConfigGtcPageContentBlockAssignments: Boolean = false) {
  cms: allTenantCms {
    id
    homepage @include(if: $withHomepage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withHomepageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withHomepageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withHomepageContentBlockAssignments) {
        id
        type
        block @include(if: $withHomepageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    categories @include(if: $withCategories) {
      id
      name
      pages @include(if: $withCategoriesPages) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCategoriesPagesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCategoriesPagesContentBlockAssignments) {
          id
          type
        }
      }
      seoSettings @include(if: $withCategoriesSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withCategoriesSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    pages @include(if: $withPages) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withPagesSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withPagesSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {
        id
        type
        block @include(if: $withPagesContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    errorPage404 @include(if: $withErrorPage404) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withErrorPage404SeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withErrorPage404SeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withErrorPage404ContentBlockAssignments) {
        id
        type
        block @include(if: $withErrorPage404ContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    errorPage500 @include(if: $withErrorPage500) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withErrorPage500SeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withErrorPage500SeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withErrorPage500ContentBlockAssignments) {
        id
        type
        block @include(if: $withErrorPage500ContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    config @include(if: $withConfig) {
      id
      contactBlockSettings @include(if: $withConfigContactBlockSettings) {
        id
        slogan
        title
        text
        phonePrefix
        phone
        phone2Prefix
        phone2
        openingHours1
        openingHours2
        email
      }
      socialMediaSettings @include(if: $withConfigSocialMediaSettings) {
        id
        facebookUrl
        instagramUrl
      }
      privacyPolicyPage @include(if: $withConfigPrivacyPolicyPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withConfigPrivacyPolicyPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withConfigPrivacyPolicyPageContentBlockAssignments) {
          id
          type
        }
      }
      gtcPage @include(if: $withConfigGtcPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withConfigGtcPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withConfigGtcPageContentBlockAssignments) {
          id
          type
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_CMS_QUERY = `query Query($id: ID!, $withHomepage: Boolean = false, $withHomepageSeoSettings: Boolean = false, $withHomepageSeoSettingsOgImage: Boolean = false, $withHomepageContentBlockAssignments: Boolean = false, $withHomepageContentBlockAssignmentsBlock: Boolean = false, $withCategories: Boolean = false, $withCategoriesPages: Boolean = false, $withCategoriesPagesSeoSettings: Boolean = false, $withCategoriesPagesContentBlockAssignments: Boolean = false, $withCategoriesSeoSettings: Boolean = false, $withCategoriesSeoSettingsOgImage: Boolean = false, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withErrorPage404: Boolean = false, $withErrorPage404SeoSettings: Boolean = false, $withErrorPage404SeoSettingsOgImage: Boolean = false, $withErrorPage404ContentBlockAssignments: Boolean = false, $withErrorPage404ContentBlockAssignmentsBlock: Boolean = false, $withErrorPage500: Boolean = false, $withErrorPage500SeoSettings: Boolean = false, $withErrorPage500SeoSettingsOgImage: Boolean = false, $withErrorPage500ContentBlockAssignments: Boolean = false, $withErrorPage500ContentBlockAssignmentsBlock: Boolean = false, $withConfig: Boolean = false, $withConfigContactBlockSettings: Boolean = false, $withConfigSocialMediaSettings: Boolean = false, $withConfigPrivacyPolicyPage: Boolean = false, $withConfigPrivacyPolicyPageSeoSettings: Boolean = false, $withConfigPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withConfigGtcPage: Boolean = false, $withConfigGtcPageSeoSettings: Boolean = false, $withConfigGtcPageContentBlockAssignments: Boolean = false) {
  cms: tenantCms(id: $id) {
    id
    homepage @include(if: $withHomepage) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withHomepageSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withHomepageSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withHomepageContentBlockAssignments) {
        id
        type
        block @include(if: $withHomepageContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    categories @include(if: $withCategories) {
      id
      name
      pages @include(if: $withCategoriesPages) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withCategoriesPagesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withCategoriesPagesContentBlockAssignments) {
          id
          type
        }
      }
      seoSettings @include(if: $withCategoriesSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withCategoriesSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
    pages @include(if: $withPages) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withPagesSeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withPagesSeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {
        id
        type
        block @include(if: $withPagesContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    errorPage404 @include(if: $withErrorPage404) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withErrorPage404SeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withErrorPage404SeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withErrorPage404ContentBlockAssignments) {
        id
        type
        block @include(if: $withErrorPage404ContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    errorPage500 @include(if: $withErrorPage500) {
      id
      name
      onlineStatus
      seoSettings @include(if: $withErrorPage500SeoSettings) {
        id
        urlSlug
        metaTitle
        metaDescription
        ogTitle
        ogDescription
        ogImage @include(if: $withErrorPage500SeoSettingsOgImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      contentBlockAssignments @include(if: $withErrorPage500ContentBlockAssignments) {
        id
        type
        block @include(if: $withErrorPage500ContentBlockAssignmentsBlock) {
          __typename
          ... on CmsTextBlock {
            id
            text

          }
          ... on CmsTextWithImageBlock {
            id
            title
            subtitle
            text
            imagePosition
            imageFixedAspectRatio

          }
          ... on CmsPageHeaderBlock {
            id
            title
            text

          }
          ... on CmsWysiwygBlock {
            id
            html

          }
          ... on CmsHeadingBlock {
            id
            importance
            heading
            addon
            decoration

          }
          ... on CmsTextWithIconBlock {
            id
            title
            text
            imagePosition

          }
          ... on CmsAccordionBlock {
            id

          }
          ... on CmsGridBlock {
            id

          }
          ... on CmsImageBlock {
            id
            text
            fluid

          }
          ... on CmsEmployeesBlock {
            id

          }
          ... on CmsContactBannerBlock {
            id
            phone
            email

          }
          ... on CmsNewsletterRegisterBlock {
            id
            fluid

          }
          ... on CmsIssuuCatalogBlock {
            id
            publicationCode
            accountName

          }
          ... on CmsFormBlock {
            id
            formName

          }
          ... on CmsHeaderSliderBlock {
            id

          }
          ... on CmsBestsellerSliderBlock {
            id
            fluid

          }
          ... on CmsFilterLeadBlock {
            id
            layout

          }
          ... on CmsTravelTypesBlock {
            id
            layout

          }
          ... on CmsPrefilteredTravelsBlock {
            id
            maxResults

          }
          ... on CmsDividerBlock {
            id
            fluid

          }
          ... on CmsTravelSelectionBlock {
            id

          }
          ... on CmsIframeBlock {
            id
            url
            minHeight

          }
          ... on CmsSliderBlock {
            id
            fluid
            size
            showDots
            showArrows
            showLightbox
            autoplay

          }
          ... on CmsDestinationsBlock {
            id

          }
          ... on CmsTravelGuidesBlock {
            id

          }
          ... on CmsBusfinderBlock {
            id
            title

          }
          ... on CmsBackgroundBlock {
            id
            backgroundVariant

          }
        }
      }
    }
    config @include(if: $withConfig) {
      id
      contactBlockSettings @include(if: $withConfigContactBlockSettings) {
        id
        slogan
        title
        text
        phonePrefix
        phone
        phone2Prefix
        phone2
        openingHours1
        openingHours2
        email
      }
      socialMediaSettings @include(if: $withConfigSocialMediaSettings) {
        id
        facebookUrl
        instagramUrl
      }
      privacyPolicyPage @include(if: $withConfigPrivacyPolicyPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withConfigPrivacyPolicyPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withConfigPrivacyPolicyPageContentBlockAssignments) {
          id
          type
        }
      }
      gtcPage @include(if: $withConfigGtcPage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withConfigGtcPageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
        }
        contentBlockAssignments @include(if: $withConfigGtcPageContentBlockAssignments) {
          id
          type
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_CMS_MUTATION = `
  mutation Mutation($input: CreateTenantCmsInput, $withHomepage: Boolean = false, $withHomepageSeoSettings: Boolean = false, $withHomepageSeoSettingsOgImage: Boolean = false, $withHomepageContentBlockAssignments: Boolean = false, $withHomepageContentBlockAssignmentsBlock: Boolean = false, $withCategories: Boolean = false, $withCategoriesPages: Boolean = false, $withCategoriesPagesSeoSettings: Boolean = false, $withCategoriesPagesContentBlockAssignments: Boolean = false, $withCategoriesSeoSettings: Boolean = false, $withCategoriesSeoSettingsOgImage: Boolean = false, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withErrorPage404: Boolean = false, $withErrorPage404SeoSettings: Boolean = false, $withErrorPage404SeoSettingsOgImage: Boolean = false, $withErrorPage404ContentBlockAssignments: Boolean = false, $withErrorPage404ContentBlockAssignmentsBlock: Boolean = false, $withErrorPage500: Boolean = false, $withErrorPage500SeoSettings: Boolean = false, $withErrorPage500SeoSettingsOgImage: Boolean = false, $withErrorPage500ContentBlockAssignments: Boolean = false, $withErrorPage500ContentBlockAssignmentsBlock: Boolean = false, $withConfig: Boolean = false, $withConfigContactBlockSettings: Boolean = false, $withConfigSocialMediaSettings: Boolean = false, $withConfigPrivacyPolicyPage: Boolean = false, $withConfigPrivacyPolicyPageSeoSettings: Boolean = false, $withConfigPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withConfigGtcPage: Boolean = false, $withConfigGtcPageSeoSettings: Boolean = false, $withConfigGtcPageContentBlockAssignments: Boolean = false) {
    cms: createTenantCms(input: $input) {
      id
      homepage @include(if: $withHomepage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withHomepageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withHomepageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withHomepageContentBlockAssignments) {
          id
          type
          block @include(if: $withHomepageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      categories @include(if: $withCategories) {
        id
        name
        pages @include(if: $withCategoriesPages) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCategoriesPagesSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCategoriesPagesContentBlockAssignments) {
            id
            type
          }
        }
        seoSettings @include(if: $withCategoriesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withCategoriesSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      pages @include(if: $withPages) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withPagesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withPagesSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {
          id
          type
          block @include(if: $withPagesContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      errorPage404 @include(if: $withErrorPage404) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withErrorPage404SeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withErrorPage404SeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withErrorPage404ContentBlockAssignments) {
          id
          type
          block @include(if: $withErrorPage404ContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      errorPage500 @include(if: $withErrorPage500) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withErrorPage500SeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withErrorPage500SeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withErrorPage500ContentBlockAssignments) {
          id
          type
          block @include(if: $withErrorPage500ContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      config @include(if: $withConfig) {
        id
        contactBlockSettings @include(if: $withConfigContactBlockSettings) {
          id
          slogan
          title
          text
          phonePrefix
          phone
          phone2Prefix
          phone2
          openingHours1
          openingHours2
          email
        }
        socialMediaSettings @include(if: $withConfigSocialMediaSettings) {
          id
          facebookUrl
          instagramUrl
        }
        privacyPolicyPage @include(if: $withConfigPrivacyPolicyPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withConfigPrivacyPolicyPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withConfigPrivacyPolicyPageContentBlockAssignments) {
            id
            type
          }
        }
        gtcPage @include(if: $withConfigGtcPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withConfigGtcPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withConfigGtcPageContentBlockAssignments) {
            id
            type
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_CMS_MUTATION = `
  mutation Mutation($input: UpdateTenantCmsInput, $withHomepage: Boolean = false, $withHomepageSeoSettings: Boolean = false, $withHomepageSeoSettingsOgImage: Boolean = false, $withHomepageContentBlockAssignments: Boolean = false, $withHomepageContentBlockAssignmentsBlock: Boolean = false, $withCategories: Boolean = false, $withCategoriesPages: Boolean = false, $withCategoriesPagesSeoSettings: Boolean = false, $withCategoriesPagesContentBlockAssignments: Boolean = false, $withCategoriesSeoSettings: Boolean = false, $withCategoriesSeoSettingsOgImage: Boolean = false, $withPages: Boolean = false, $withPagesSeoSettings: Boolean = false, $withPagesSeoSettingsOgImage: Boolean = false, $withPagesContentBlockAssignments: Boolean = false, $withPagesContentBlockAssignmentsBlock: Boolean = false, $withErrorPage404: Boolean = false, $withErrorPage404SeoSettings: Boolean = false, $withErrorPage404SeoSettingsOgImage: Boolean = false, $withErrorPage404ContentBlockAssignments: Boolean = false, $withErrorPage404ContentBlockAssignmentsBlock: Boolean = false, $withErrorPage500: Boolean = false, $withErrorPage500SeoSettings: Boolean = false, $withErrorPage500SeoSettingsOgImage: Boolean = false, $withErrorPage500ContentBlockAssignments: Boolean = false, $withErrorPage500ContentBlockAssignmentsBlock: Boolean = false, $withConfig: Boolean = false, $withConfigContactBlockSettings: Boolean = false, $withConfigSocialMediaSettings: Boolean = false, $withConfigPrivacyPolicyPage: Boolean = false, $withConfigPrivacyPolicyPageSeoSettings: Boolean = false, $withConfigPrivacyPolicyPageContentBlockAssignments: Boolean = false, $withConfigGtcPage: Boolean = false, $withConfigGtcPageSeoSettings: Boolean = false, $withConfigGtcPageContentBlockAssignments: Boolean = false) {
    cms: updateTenantCms(input: $input) {
      id
      homepage @include(if: $withHomepage) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withHomepageSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withHomepageSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withHomepageContentBlockAssignments) {
          id
          type
          block @include(if: $withHomepageContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      categories @include(if: $withCategories) {
        id
        name
        pages @include(if: $withCategoriesPages) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withCategoriesPagesSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withCategoriesPagesContentBlockAssignments) {
            id
            type
          }
        }
        seoSettings @include(if: $withCategoriesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withCategoriesSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
      }
      pages @include(if: $withPages) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withPagesSeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withPagesSeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withPagesContentBlockAssignments) {
          id
          type
          block @include(if: $withPagesContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      errorPage404 @include(if: $withErrorPage404) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withErrorPage404SeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withErrorPage404SeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withErrorPage404ContentBlockAssignments) {
          id
          type
          block @include(if: $withErrorPage404ContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      errorPage500 @include(if: $withErrorPage500) {
        id
        name
        onlineStatus
        seoSettings @include(if: $withErrorPage500SeoSettings) {
          id
          urlSlug
          metaTitle
          metaDescription
          ogTitle
          ogDescription
          ogImage @include(if: $withErrorPage500SeoSettingsOgImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        contentBlockAssignments @include(if: $withErrorPage500ContentBlockAssignments) {
          id
          type
          block @include(if: $withErrorPage500ContentBlockAssignmentsBlock) {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              phone
              email

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
          }
        }
      }
      config @include(if: $withConfig) {
        id
        contactBlockSettings @include(if: $withConfigContactBlockSettings) {
          id
          slogan
          title
          text
          phonePrefix
          phone
          phone2Prefix
          phone2
          openingHours1
          openingHours2
          email
        }
        socialMediaSettings @include(if: $withConfigSocialMediaSettings) {
          id
          facebookUrl
          instagramUrl
        }
        privacyPolicyPage @include(if: $withConfigPrivacyPolicyPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withConfigPrivacyPolicyPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withConfigPrivacyPolicyPageContentBlockAssignments) {
            id
            type
          }
        }
        gtcPage @include(if: $withConfigGtcPage) {
          id
          name
          onlineStatus
          seoSettings @include(if: $withConfigGtcPageSeoSettings) {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          contentBlockAssignments @include(if: $withConfigGtcPageContentBlockAssignments) {
            id
            type
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_CMS_MUTATION = `
  mutation Mutation($input: DeleteTenantCmsInput) {
    deleteTenantCms(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CMS_MUTATION = `
  mutation Mutation($input: DeleteTenantCmsInput) {
    forceDeleteTenantCms(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_CMS_CATEGORIES_MUTATION = `
  mutation Mutation($input: addTenantCmsCategoriesInput) {
    addTenantCmsCategories(input: $input) {
      id
      categoryIds
    }
  }`

// language=GraphQL
export const REMOVE_CMS_CATEGORIES_MUTATION = `
  mutation Mutation($input: removeTenantCmsCategoriesInput) {
    removeTenantCmsCategories(input: $input) {
      id
      categoryIds
    }
  }`

// language=GraphQL
export const CREATE_CMS_CATEGORIES_MUTATION = `
  mutation Mutation($input: createTenantCmsCategoriesInput) {
    createTenantCmsCategories(input: $input) {
      id
      categoryIds
    }
  }`

// language=GraphQL
export const DELETE_CMS_CATEGORIES_MUTATION = `
  mutation Mutation($input: deleteTenantCmsCategoriesInput) {
    deleteTenantCmsCategories(input: $input) {
      id
      categoryIds
    }
  }`

// language=GraphQL
export const UPDATE_CMS_CATEGORIES_ORDER_MUTATION = `
  mutation Mutation($input: updateTenantCmsCategoriesOrderInput) {
    updateTenantCmsCategoriesOrder(input: $input) {
      id
      categoryIds
    }
  }`

// language=GraphQL
export const ADD_CMS_PAGES_MUTATION = `
  mutation Mutation($input: addTenantCmsPagesInput) {
    addTenantCmsPages(input: $input) {
      id
      pageIds
    }
  }`

// language=GraphQL
export const REMOVE_CMS_PAGES_MUTATION = `
  mutation Mutation($input: removeTenantCmsPagesInput) {
    removeTenantCmsPages(input: $input) {
      id
      pageIds
    }
  }`

// language=GraphQL
export const CREATE_CMS_PAGES_MUTATION = `
  mutation Mutation($input: createTenantCmsPagesInput) {
    createTenantCmsPages(input: $input) {
      id
      pageIds
    }
  }`

// language=GraphQL
export const DELETE_CMS_PAGES_MUTATION = `
  mutation Mutation($input: deleteTenantCmsPagesInput) {
    deleteTenantCmsPages(input: $input) {
      id
      pageIds
    }
  }`

// language=GraphQL
export const CMS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTenants: Boolean = false) {
  groupedDependents: tenantCmsDependents(id: $id) {
    tenants @include(if: $withTenants) {
      id
      name
      slug
      domain
      externalReference
    }
  }
}`
